<template>
  <FormModal
    title="Edit Country Region"
    :endpoint="`countries/${countryId}/country-regions/${countryRegionId}`"
    method="PUT"
    :data="data"
    v-bind="$attrs"
    @success="success"
  >
    <InputGroup label="Name" name="name">
      <TextInput v-model="data.name" />
    </InputGroup>

    <InputGroup label="Abbreviation" name="abbreviation">
      <TextInput v-model="data.abbreviation" />
    </InputGroup>
  </FormModal>
</template>

<script>
export default {
  props: {
    countryId: {
      type: Number,
      required: true
    },
    countryRegionId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: true,
    data: {
      name: "",
      abbreviation: ""
    }
  }),
  async created() {
    let { data } = await this.$api.get(`countries/${this.countryId}/country-regions/${this.countryRegionId}`)
    this.data.name = data.data.name
    this.data.abbreviation = data.data.abbreviation
  },
  methods: {
    success(result) {
      this.$notification.success(`**${this.data.name}** successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
